import { Query } from '@psl/functions/firebase/firebaseAccess';
import { storeCategorizedResourcesQuery } from '@psl/functions/firebase/queries/stores/storeCategorizedResourcesQuery';
import {
  collectionDataWithId,
  WithID,
} from '@psl/functions/firebase/rxfireExtensions';
import { CategorizedStore } from '@psl/models/ClientModels';
import { sort } from 'ramda';
import { map } from 'rxjs';

export const storeCategories$ = (uid: string) =>
  collectionDataWithId<CategorizedStore>(
    storeCategorizedResourcesQuery(uid) as unknown as Query<CategorizedStore>,
  ).pipe(map(sortedCategories));

export function sortedCategories(
  categories: WithID<CategorizedStore>[],
): WithID<CategorizedStore>[] {
  return sort(compareStoreCategory, categories);
}

export function compareStoreCategory(x: CategorizedStore, y: CategorizedStore) {
  const [a, b] = [
    x.sequenceNo ?? x.createdAt.toMillis(),
    y.sequenceNo ?? y.createdAt.toMillis(),
  ];
  return a < b ? -1 : 1;
}
